module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Rossenges_(Vaud)-988cb6e9b7af8d779e95fcda5bfbd9ff.svg";